import { DatePicker, Divider, Select, Radio } from "antd";
import React from "react";
import FileUpload from "../../../../ant-components/file-upload";
import { UserRound } from "lucide-react";
import { Man, Woman } from "../../../../constant/imgages";
import { useSelector, useDispatch } from "react-redux";
import { updateField } from "../../../../redux/slices/employee-slice";
import dayjs from "dayjs";

const GenInfo = () => {
  const dispatch = useDispatch();
  const form = useSelector((state) => state.employeeForm);

  const getGenderImage = () => {
    if (form.gender === 'male') return Man;
    if (form.gender === 'female') return Woman;
    return null; // For 'other' or no selection
  };

  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "other", label: "Other" },
  ];

  const bloodGroupOptions = [
    { value: "A+", label: "A+" },
    { value: "A-", label: "A-" },
    { value: "B+", label: "B+" },
    { value: "B-", label: "B-" },
    { value: "O+", label: "O+" },
    { value: "O-", label: "O-" },
    { value: "AB+", label: "AB+" },
    { value: "AB-", label: "AB-" },
  ];

  const religionOptions = [
    { value: "Muslim", label: "Muslim" },
    { value: "Hindu", label: "Hindu" },
    { value: "Sikh", label: "Sikh" },
    { value: "Christian", label: "Christian" },
    { value: "Other", label: "Other" },
  ];

  const qualificationOptions = [
    { value: "Matric", label: "Matric" },
    { value: "Inter", label: "Inter" },
    { value: "Bachelor", label: "Bachelor" },
    { value: "Master", label: "Master" },
    { value: "PHD", label: "PHD" },
  ];

  const maritalStatusOptions = [
    { value: "Single", label: "Single" },
    { value: "Married", label: "Married" },
    { value: "Divorced", label: "Divorced" },
    { value: "Widow", label: "Widow" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(updateField({ name, value }));
  };

  const handleSelectChange = (value, name) => {
    dispatch(updateField({ name, value }));
  };

  const handleDateChange = (dateString) => {
    dispatch(updateField({ name: "dob", value: dateString }));
  };

  const handleImageChange = (url) => {
    dispatch(updateField({ name: "image", value: url }));
  };

  return (
    <div className="flex items-start justify-between bg-white px-4">
      <div className="flex flex-col gap-3 mt-8">
        <UserRound className="h-7 w-7 text-active-color stroke-1" />
        <h4 className="font-bold text-md">General Information</h4>
        <p className="text-gray-400 text-md -mt-2">
          Fill in the employee's personal data.
        </p>
      </div>
      <div className="bg-form-bg w-lg rounded-md px-4 flex flex-col gap-6 py-8 mr-8">
        {form.gender !== 'other' && (
          <>
          <div className="mx-auto border-[1.5px] border-active-color h-20 w-20 rounded-full">
            {form.image ? (
              <img
                src={form.image}
                alt="User"
                className="object-cover h-full w-full rounded-full"
              />
            ) : (
              <img
                src={getGenderImage()}
                alt="Gender"
                className="object-cover h-full w-full rounded-full"
              />
            )}
          </div>
           <Divider />
           </>
        )}
       
        <div className="flex flex-col gap-2 text-md">
          <label>Gender</label>
          <Radio.Group 
            value={form.gender}
            onChange={(e) => handleSelectChange(e.target.value, "gender")}
          >
            {genderOptions.map((option) => (
              <Radio key={option.value} value={option.value}>
                {option.label}
              </Radio>
            ))}
          </Radio.Group>
        </div>
        <FileUpload onChange={handleImageChange} file={form.image} />
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-6 flex flex-col gap-6">
            <div className="flex flex-col gap-1">
              <label htmlFor="fname" className="text-md">
                First Name
                <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
              </label>
              <input
                type="text"
                className="border px-2 py-1 rounded-md border-secondary disabled:bg-secondary text-md outline-none bg-white"
                placeholder="First Name"
                name="firstName"
                onChange={handleChange}
                value={form.firstName}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="fname" className="text-md">
                Father Name
              </label>
              <input
                type="text"
                className="border px-2 py-1 rounded-md border-secondary disabled:bg-secondary text-md outline-none bg-white"
                placeholder="Father Name"
                name="fatherName"
                onChange={handleChange}
                value={form.fatherName}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="passweord" className="text-md">
                Password
              </label>
              <input
                type="text"
                className="border px-2 py-1 rounded-md border-secondary disabled:bg-secondary text-md outline-none bg-white"
                placeholder=""
                name="password"
                onChange={handleChange}
                value={form.password}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="fname" className="text-md">
                Blood Group
              </label>
              <Select
                placeholder="Select One"
                options={bloodGroupOptions}
                value={form.bloodGroup}
                onChange={(value) => handleSelectChange(value, "bloodGroup")}
                className="w-full"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="dob" className="text-md">
                DOB
              </label>
              <DatePicker
                onChange={handleDateChange}
                placeholder="YYYY/MM/DD"
                className="w-full"
                value={form.dob ? dayjs(form.dob) : null}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="fname" className="text-md">
                Religion
              </label>
              <Select
                placeholder="Select One"
                options={religionOptions}
                value={form.religion}
                onChange={(value) => handleSelectChange(value, "religion")}
                className="w-full"
              />
            </div>
            
          </div>
          <div className="col-span-6 flex flex-col gap-6">
          <div className="flex flex-col gap-1">
              <label htmlFor="lname" className="text-md">
                Last Name{" "}
                <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
              </label>
              <input
                type="text"
                className="border px-2 py-1 rounded-md border-secondary disabled:bg-secondary text-md outline-none bg-white"
                placeholder="Last Name"
                name="lastName"
                onChange={handleChange}
                value={form.lastName}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="email" className="text-md">
                Work Email
              </label>
              <input
                type="email"
                className="border px-2 py-1 rounded-md border-secondary disabled:bg-secondary text-md outline-none bg-white"
                placeholder="Work Email"
                name="emailAddress"
                onChange={handleChange}
                value={form.emailAddress}
              />
            </div>
           
            <div className="flex flex-col gap-1">
              <label htmlFor="qualification" className="text-md">
                Qualification
              </label>
              <Select
                className="w-full"
                placeholder="Select One"
                name="qualification"
                onChange={(value) => handleSelectChange(value, 'qualification')}
                value={form.qualification}
                options={qualificationOptions}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="maritalStatus" className="text-md">
                Marital Status
              </label>
              <Select
                className="w-full"
                placeholder="Select One"
                name="maritalStatus"
                onChange={(value) => handleSelectChange(value, 'maritalStatus')}
                value={form.maritalStatus}
                options={maritalStatusOptions}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="fname" className="text-md">
                Contact Number
              </label>
              <input
                type="text"
                className="border px-2 py-1 rounded-md border-secondary disabled:bg-secondary text-md outline-none bg-white"
                placeholder="Contact Number"
                value={form.contact_number}
                onChange={handleChange}
                name="contact_number"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenInfo;
